import { render, staticRenderFns } from "./domain.vue?vue&type=template&id=d77b6d6c&scoped=true"
import script from "./domain.vue?vue&type=script&lang=js"
export * from "./domain.vue?vue&type=script&lang=js"
import style0 from "./domain.vue?vue&type=style&index=0&id=d77b6d6c&prod&scoped=true&lang=css"
import style1 from "./domain.vue?vue&type=style&index=1&id=d77b6d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77b6d6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VDivider,VTab,VTabItem,VTabs})
